import React from "react";
import PropTypes from "prop-types";
import "./nextSteps.scss";

const NextSteps = ({nextSteps}) => {
    return <ul className={"next-steps-list"}>
        {
            nextSteps.map(({step}, index) => <li className={"next-step"} key={index}>{step}</li>)
        }
    </ul>
}

NextSteps.prototype = {
    nextSteps: PropTypes.arrayOf(PropTypes.shape({
        step: PropTypes.string,
        time: PropTypes.string,
        user: PropTypes.string
    }))
}
export default NextSteps;